<template>
    <div>
        <SubHeader text="CUSTOMER" :imgUrl="imgUrl" />
        <Construction />
    </div>
</template>
<script>
import SubHeader from "@/components/SubHeader.vue";
import Construction from "./Construction.vue";
import initAnimation from "../animation"
export default {
    data() {
        return {
            imgUrl: require("@/assets/images/sub_page_banner_6.jpg"),
        };
    },
    mounted(){
        setTimeout(initAnimation,0);
    },
    components: {
        SubHeader,
        Construction,
    },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/Pages/Customer/All.vue